module.exports = __webpack_public_path__ + "media/src/components/shared/loaders/img/loading-48172835a7daa803b9ceb02a47266fc9.gif";